import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(unautorized)/(embed-iframes)/layout.tsx");
